import * as React from 'react';
import { IconChevronRightSmall16, Tags } from '@cian/ui-kit';
import * as styles from './LocationBreadcrumbs.css';

export interface IBreadcrumb {
  regionId: number;
  displayName: string;
  isSelected: boolean;
}

export interface ILocationBreadcrumbsProps {
  list: IBreadcrumb[];
  onItemClick(type: 'link' | 'button', index: number): void;
}

export const LocationBreadcrumbs: React.VFC<ILocationBreadcrumbsProps> = ({ list, onItemClick }) => {
  return (
    <div className={styles['list']}>
      {list.map((item, index) => (
        <div key={item.regionId + index} className={styles['item']}>
          {index !== 0 && (
            <div className={styles['arrow']}>
              <IconChevronRightSmall16 display="block" />
            </div>
          )}
          {item.isSelected ? (
            <Tags
              options={[{ value: item.regionId.toString(), label: item.displayName }]}
              onClose={() => onItemClick('button', index)}
            />
          ) : (
            <span tabIndex={0} className={styles['link']} onClick={() => onItemClick('link', index)}>
              {item.displayName}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
